<template>
    <generic-page>
        <b-btn variant="link" size="lg" class="pl-0" to="/account/call/index">
            <font-awesome-icon size="lg" icon="fa-light fa-chevron-left" />
            {{ $t("All Calls") }}
        </b-btn>

        <div v-if="randomCall">
            <div @click="viewProfile">
                <user-standard-avatar
                    :standardMap="standardMap"
                    :nonPrimaryPhotos="false"
                    :hideBadges="true"
                    :userBetweenStatus="false"
                    size="small"
                    class="border-light border-top"
                />
            </div>

            <h5 class="mt-3">{{ $t("Random Call Details") }}</h5>
            <b-list-group>
                <b-list-group-item
                    class="d-flex align-items-center justify-content-between"
                >
                    <div>{{ $t("Status") }}</div>
                    <div class="small">
                        <b-badge :variant="randomCall.statusVariant">
                            {{ randomCall.status }}
                        </b-badge>
                    </div>
                </b-list-group-item>
                <b-list-group-item
                    v-if="randomCall.duration"
                    class="d-flex align-items-center justify-content-between"
                >
                    <div>{{ $t("Duration") }}</div>
                    <div class="small">
                        {{ randomCall.duration }}
                    </div>
                </b-list-group-item>
                <b-list-group-item
                    v-if="randomCall.totalEarnings"
                    class="d-flex align-items-center justify-content-between"
                >
                    <div>{{ customerLabel }}</div>
                    <coin-badge :amount="randomCall.totalEarnings" />
                </b-list-group-item>
                <b-list-group-item
                    v-if="randomCall.escrow"
                    class="d-flex align-items-center justify-content-between"
                >
                    <div>{{ $t("Credits on Hold") }}</div>
                    <font-awesome-icon
                        class="text-success"
                        icon="fa-light fa-check"
                    />
                </b-list-group-item>
                <b-list-group-item
                    v-if="randomCall.refundAmount"
                    class="d-flex align-items-center justify-content-between"
                >
                    <div>{{ $t("Amount Refunded") }}</div>
                    <coin-badge :amount="randomCall.refundAmount" />
                </b-list-group-item>
                <b-list-group-item
                    v-if="randomCall.rating"
                    class="d-flex align-items-center justify-content-between"
                >
                    <div>{{ $t("Rating") }}</div>
                    <div class="small">
                        {{ randomCall.rating }} / 5
                    </div>
                </b-list-group-item>
            </b-list-group>
        </div>
        <div v-else>
            <generic-loading />
        </div>
    </generic-page>
</template>

<script>
import { mapState } from "vuex";

import UserStandardAvatar from "@/components/user/UserStandardAvatar";

export default {
    data() {
        return {
            randomCall: false,
            standardMap: false,
        };
    },
    computed: {
        ...mapState({
            onboardingUser: (state) => state.onboarding.user,
        }),
        customerLabel() {
            return this.onboardingUser?.creator
                ? this.$t("Total Earned")
                : this.$t("Total Spent");
        },
    },
    mounted() {
        this.refresh();
    },
    watch: {
        $route(to) {
            if (to?.params?.id !== this.randomCall?.id || to?.query?.forceRefresh) {
                this.refresh();
            }
        },
    },
    methods: {
        viewProfile() {
            this.$store.dispatch("profile/viewProfile", {
                userId: this.standardMap.id,
                profile: this.standardMap,
            });
        },
        refresh() {
            const id = this.$route.params?.id;

            this.api.post(`/randomCall/${id}/get`).then((response) => {
                this.randomCall = response?.data?.randomCall;
                this.standardMap = response?.data?.standardMap;
            });
        },
    },
    components: {
        UserStandardAvatar,
    },
};
</script>
